class ProductSubscriptionScripts {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener("click", (e) => {
            if (e.target.closest(".product-subs-collagen__button")) {
                const target = e.target.closest(".product-subs-collagen__button");
                const price = target.getAttribute("data-price");
                const container = target.closest("[data-subs-container]");
                const selectorElement = container.querySelector("[data-subs-selector]");
                const targetWrapper = target.closest("[data-skio-item]");
                const quantityPicker = document.getElementById('quantityPicker');

                if (targetWrapper) {
                    [...container.querySelectorAll("[data-skio-item].active")].map(button => button.classList.remove("active"));
                    targetWrapper.classList.add("active");
                }

                [...container.querySelectorAll(".product-subs-collagen__button.active")].map(button => button.classList.remove("active"));
                [...document.querySelectorAll(".totprice")].map(item => item.innerText = price);

                target.classList.add("active");
                
                const isSubscription = target.hasAttribute("data-selling-plan-button");
                
                if (isSubscription) {
                    if (quantityPicker) {
                        quantityPicker.classList.remove('visible');
                        quantityPicker.classList.add('unvisible');
                    }
                    
                    if (selectorElement) {
                        if (!selectorElement.classList.contains("active")) {
                            selectorElement.classList.add("active")
                        }
                    }
                    document.querySelectorAll(".comprice").forEach(el => el.style.display = "");
                } else {
                    if (quantityPicker) {
                        quantityPicker.classList.remove('unvisible');
                        quantityPicker.classList.add('visible');
                    }
                    if (selectorElement) {
                        if (selectorElement.classList.contains("active")) {
                            selectorElement.classList.remove("active");
                        }
                    }
                    document.querySelectorAll(".comprice").forEach(el => el.style.display = "none");
                }
            }

            if (e.target.closest("[data-subs-selector-button]")) {
                const target = e.target.closest("[data-subs-selector-button]");
                const selectorElement = target.closest("[data-subs-selector]");
                
                if (selectorElement) {
                    const dropdownElement = selectorElement.querySelector("[data-subs-dropdown]");

                    if (dropdownElement) {
                        dropdownElement.classList.toggle("active");
                        target.classList.toggle("active");
                    }
                }
            }

            if (e.target.closest("[data-subs-selling-plan-id]")) {
                const allPrices = document.querySelectorAll(".totprice");
                const allComPrices = document.querySelectorAll(".comprice");
                const target = e.target.closest("[data-subs-selling-plan-id]");
                const sellingPlanName = target.innerText;
                const sellingPlanId = target.getAttribute("data-subs-selling-plan-id");
                const sellingPlanPrice = target.getAttribute("data-subs-selling-plan-price");

                const container = target.closest("[data-subs-container]");
                const quantityPicker = document.getElementById('quantityPicker');

                if (container) {
                    const activePurchase = container.querySelector(".hp-purchase-item.purchase-active");
                    const priceEls = container.querySelectorAll('[data-subs-price-new]');
                    const sellingPlanButton = container.querySelector("[data-selling-plan-button]");
                    const selectorButtonText = container.querySelector("[data-subs-selector-button-text]");
                    const activeDropdowns = container.querySelectorAll(".product-subs-collagen__dropdown-item.active, [data-subs-dropdown].active");

                    if (sellingPlanPrice) {
                        this.updatePrice([...priceEls], sellingPlanPrice);
                        this.updatePrice([...allPrices], sellingPlanPrice);

                        if (activePurchase) {
                            activePurchase.setAttribute("data-price", sellingPlanPrice);
                        }
                    }

                    [...activeDropdowns].map(item => item.classList.remove("active"));
                    target.classList.add("active");

                    if (sellingPlanButton && selectorButtonText && sellingPlanButton) {
                        sellingPlanButton.setAttribute("data-id", sellingPlanId);
                        selectorButtonText.innerText = sellingPlanName;
                    }
                    const isOneTime = sellingPlanId === "one-time" || sellingPlanName.toLowerCase().includes("one time");
                    
                    if (isOneTime) {
                        if (quantityPicker) {
                            quantityPicker.classList.remove('unvisible');
                            quantityPicker.classList.add('visible');
                        }
                        allComPrices.forEach(el => el.style.display = "none");
                    } else {
                        if (quantityPicker) {
                            quantityPicker.classList.remove('visible');
                            quantityPicker.classList.add('unvisible');
                        }
                        allComPrices.forEach(el => el.style.display = "");
                    }
                }
            }
        });
        
        const quantityPicker = document.getElementById('quantityPicker');
        if (quantityPicker) {
            quantityPicker.classList.remove('visible');
            quantityPicker.classList.add('unvisible');
        }
    }

    updatePrice(items, value) {
        if (items && items.length > 0) {
            items.map(item => item.innerText = value);
        }
    }
}

new ProductSubscriptionScripts();